import { authorizedFetch } from '../../helpers/authorizedFetch'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import isResourceCollectionDocument from '../../japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '../../japi/types/Document'
import { FetchCollectionResult, FetchResultType } from '../FetchResult'
import { Role, RoleResource } from './Role'
import { transformToRole } from './RoleTransformers'

export const getRolesApiCall = async (): Promise<FetchCollectionResult<Role[], string>> => {
    try {
        const url = generateApiUrl({ endpoint: '/roles' })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<RoleResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const roles = doc.data.map(transformToRole)

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: roles,
        }
    } catch (error) {
        console.error('[getRolesApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
